export const visit = "Visit"
export const cleaning = "Cleaning"
export const CleaningCompanies = "Cleaning Companies"
export const Config = "Admin Config"
export const CleanersDashboard = "Dashboard"
export const CleaningSchedule = "Schedule Upload & Download" 
export const ModifySchedule = "Modify Schedule"
export const ManageUser = "Manage User"
export const Logout = "Logout"
export const Help = "Help"